var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgWechat = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "weechat account connect") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.292969,
    width: 34,
    height: 34,
    rx: 17,
    fill: "#1F408C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4291 8.29297C10.1683 8.29297 6.71484 11.1717 6.71484 14.7215C6.71484 16.7684 7.86942 18.5838 9.66041 19.759L8.64342 21.793L11.4141 20.6063C12.0081 20.8171 12.6253 20.9907 13.2848 21.0717C13.1948 20.6795 13.1434 20.2771 13.1434 19.8644C13.1434 16.3197 16.6033 13.4358 20.8577 13.4358C21.2473 13.4358 21.6278 13.468 22.0033 13.5143C21.3244 10.5417 18.1937 8.29297 14.4291 8.29297ZM11.8577 13.1144C11.3254 13.1144 10.8934 12.6824 10.8934 12.1501C10.8934 11.6178 11.3254 11.1858 11.8577 11.1858C12.39 11.1858 12.822 11.6178 12.822 12.1501C12.822 12.6824 12.39 13.1144 11.8577 13.1144ZM17.0006 13.1144C16.4683 13.1144 16.0363 12.6824 16.0363 12.1501C16.0363 11.6178 16.4683 11.1858 17.0006 11.1858C17.5328 11.1858 17.9648 11.6178 17.9648 12.1501C17.9648 12.6824 17.5328 13.1144 17.0006 13.1144Z",
    fill: "#4987FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2852 19.8655C27.2852 17.0254 24.4065 14.7227 20.8566 14.7227C17.3068 14.7227 14.428 17.0254 14.428 19.8655C14.428 22.7057 17.3068 25.0084 20.8566 25.0084C21.4403 25.0084 21.9958 24.9261 22.5345 24.8091L25.9995 26.2941L24.8012 23.8988C26.3029 22.9577 27.2852 21.5099 27.2852 19.8655ZM18.928 19.5441C18.3958 19.5441 17.9638 19.1121 17.9638 18.5798C17.9638 18.0475 18.3958 17.6155 18.928 17.6155C19.4603 17.6155 19.8923 18.0475 19.8923 18.5798C19.8923 19.1121 19.4603 19.5441 18.928 19.5441ZM22.7852 19.5441C22.2529 19.5441 21.8209 19.1121 21.8209 18.5798C21.8209 18.0475 22.2529 17.6155 22.7852 17.6155C23.3175 17.6155 23.7495 18.0475 23.7495 18.5798C23.7495 19.1121 23.3175 19.5441 22.7852 19.5441Z",
    fill: "#4987FF"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgWechat);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/wechat.acd863351dba4a72c0ea762a41271e09.svg";